define('responsive-gameday/controllers/GamePanelViewController',['require','exports','module','Responsive/controllers/ScrollPanelViewController','GameDayCore','./PlayerCardViewController'],function(require, exports, module) {
	// Add private variables here
	var ScrollPanelViewController = require("Responsive/controllers/ScrollPanelViewController"),
		GDC = require("GameDayCore"),
        PlayerCardViewController = require("./PlayerCardViewController");

	var Superclass;

	// Constructor
	function GamePanelViewController(options) {
		Superclass.constructor.call(this, options);
		var self = this;
	};

	ScrollPanelViewController.spawn(GamePanelViewController).define({
		loadView: function() {
			var that = this,
				playerCard = this.config.playerCards !== false && new PlayerCardViewController(this, this.config.playerCards) ||
					( PlayerCardViewController.supress() ),
				// state = GDC.getHashParams().game_state,
				start = (GDC.getCachedParams().game_tab||"").toLowerCase();

			this.start = !this.started && start && (this.views.some(function(v, i) {
				return (v.id||"").toLowerCase() === start ? (start = i, true) : false;
			}) ? start : ~~start) || false;

			if (this.start === false && start != null) {
				this.start = this.prev = this.prev || this.focus || 0;
			}

			this.playerCard = playerCard;
	        this.header = this.config.header || null;

			// this.started=true;
			Superclass.loadView.call(this);
			if (!playerCard) {
				// this.setClassName('noPlayerCard');
			} else {
				playerCard.on();
			}
			if (this.config.isLive) {
				this.setClassName('liveTab');
			}
		},

        draw : function(){
            Superclass.draw.call(this);
            if(this.header){
                this.header.viewWillAppear();
                this.getView().insertBefore(this.header.getView(),this.viewHolder);
                this.header.viewDidAppear();
            }

        },

		viewDidUnload: function() {
			if (this.header) {
				this.header.viewWillDisappear();
				this.header.viewDidDisappear();
				this.header.viewDidUnload();
				this.header = null;
			}
			if (this.config.playerCards === false) {
				PlayerCardViewController.release();
			}else{
				this.playerCard.off();
			}
			if (this.playerCard) {
				this.playerCard.viewWillDisappear();
				this.playerCard.viewDidDisappear();
				this.playerCard.viewDidUnload();
			}
			Superclass.viewDidUnload.call(this);
		},
		setFullscreenCard: function(val) {
			this.fullscreenCard = val;
		},
		setViewFocus: function(index) {
			var focus = this.focus;
			Superclass.setViewFocus.call(this, index);
			if (focus !== index && index === this.focus && this.slots[this.focus]) {
				GDC.setHashParams({
					game_tab: (this.slots[this.focus].id).toLowerCase()
				});
			}

		}
	});

	Superclass = GamePanelViewController.superclass;
	return GamePanelViewController;
});
